// extracted by mini-css-extract-plugin
export default {"spinner":"Loader_spinner__h3u3M","spinner-aib1d7":"Loader_spinner-aib1d7__nfhR4"};